import { OrgUser } from '@/models/User/OrgUser';
import { UserHistory } from '@/models/User/UserHistory';
import { useState, createContext, useContext, JSX } from 'react';
import { UserPrivateSettingsOnAzure } from '../../../generated-client/models';

type UserUpdaterContextType = {
  orgUser: OrgUser | null;
  updateOrgUser: (newOrgUser: OrgUser) => void;
  userHistory: UserHistory | null;
  updateUserHistory: (newUserHistory: UserHistory) => void;
  userPrivateSettings: UserPrivateSettingsOnAzure | null;
  updateUserPrivateSettings: (
    newUserPrivateSettings: UserPrivateSettingsOnAzure,
  ) => void;
  userRole: string | null;
};

export const UserUpdaterContext = createContext<UserUpdaterContextType>({
  orgUser: null,
  updateOrgUser: (_: OrgUser) => {},
  userHistory: null,
  updateUserHistory: (_: UserHistory) => {},
  userPrivateSettings: null,
  updateUserPrivateSettings: (_: UserPrivateSettingsOnAzure) => {},
  userRole: null,
});

export const UserUpdaterProvider = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const [orgUser, setOrgUser] = useState<OrgUser | null>(null);
  /**
   * @type {[UserHistory|null, Function]}
   */
  const [userHistory, setUserHistory] = useState<UserHistory | null>(null);
  const [userPrivateSettings, setUserPrivateSettings] =
    useState<UserPrivateSettingsOnAzure | null>(null);
  const [userRole, setUserRole] = useState<string | null>(null);

  /**
   * Updates the org user state and user role.
   * @param {OrgUser} newOrgUser
   */
  const updateOrgUser = (newOrgUser: OrgUser) => {
    setOrgUser(newOrgUser);
    setUserRole(newOrgUser.role);
  };

  /**
   *
   * @param {UserHistory} newUserHistory
   */
  const updateUserHistory = (newUserHistory: UserHistory) => {
    setUserHistory(newUserHistory);
  };

  const updateUserPrivateSettings = (
    newUserPrivateSettings: UserPrivateSettingsOnAzure,
  ) => {
    setUserPrivateSettings(newUserPrivateSettings);
  };
  return (
    <UserUpdaterContext.Provider
      value={{
        orgUser,
        updateOrgUser,
        userHistory,
        updateUserHistory,
        userPrivateSettings,
        updateUserPrivateSettings,
        userRole,
      }}
    >
      {children}
    </UserUpdaterContext.Provider>
  );
};

/**
 * Custom hook to access the UserUpdaterContext.
 * @returns {UserUpdaterContextType}
 */
export const useUserUpdaterProvider = () => {
  return useContext(UserUpdaterContext);
};
